import { t } from "@travily/i18n";
import { FieldSet } from "@ui/components/FieldSet";
import { PriceRange } from "@ui/components/PriceRange";
import { MarketplaceTypeFilter, type MarketplaceTypeFilterValue } from "./MarketplaceTypeFilter";

export interface MarketplaceFiltersProps {
  currencySymbol?: string;
  onPriceChange: (range: [number, number]) => void;
  onTypeChange: (value: MarketplaceTypeFilterValue) => void;
  priceRange: { max: number; min: number };
  priceValue: [number, number];
  typeValue: MarketplaceTypeFilterValue;
}

export function MarketplaceFilters({
  currencySymbol,
  onPriceChange,
  onTypeChange,
  priceRange,
  priceValue,
  typeValue,
}: MarketplaceFiltersProps) {
  return (
    <FieldSet.List size="lg">
      <FieldSet>
        <FieldSet.Legend>{t("components.views.shared.marketplace_search.type_label")}</FieldSet.Legend>
        <MarketplaceTypeFilter onChange={onTypeChange} value={typeValue} />
      </FieldSet>
      <FieldSet>
        <FieldSet.Legend>{t("components.views.shared.marketplace_search.price_range_label")}</FieldSet.Legend>
        <PriceRange
          currencySymbol={currencySymbol}
          max={priceRange.max}
          min={priceRange.min}
          onChange={onPriceChange}
          value={priceValue}
        />
      </FieldSet>
    </FieldSet.List>
  );
}
